export const uglaFile = `{
    "assets": [
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_1.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_3_color_2_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_3_color_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_3_color_1_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_3_color_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_4_color_1_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
                        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_4_color_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
                                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_4_color_2_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
                                        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_4_color_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_1_color_2.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_1_color_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_2.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_2_color_2.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_2_color_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Campagne",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchne_1_face_1.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_3.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_3_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_3_color1.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
         {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_3_color1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "3",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_1_color_1.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_2.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_2_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_4_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_4_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#606A74FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_4_color_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
                                {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_4_color_1_close.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "4",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_2_color_1.png",
            "tags": [
                {
                    "value": "close",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_2_color_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "2",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        },
        {
            "type": "2D",
            "url": "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_1_face_1_color_1_open.png",
            "tags": [
                {
                    "value": "open",
                    "key": "state"
                },
                {
                    "value": "#B27B65FF",
                    "key": "color"
                },
                {
                    "value": "1",
                    "key": "pov"
                },
                {
                    "value": "Brooklyn",
                    "key": "name"
                }
            ]
        }
    ],
    "scene": [],
    "interactions": {}
}`;
